module.exports = __webpack_public_path__ + "static/img/products_redmud_mobile.3fef5082.jpg";